// lib
import React, { useState } from "react";
import PropTypes from "prop-types";
import { SketchPicker } from "react-color";
import { Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Check } from "@material-ui/icons";
// src
import { DEFAULT_MINE_COLOR, COLORS } from "utils/colors";

const PRESET_COLORS = [DEFAULT_MINE_COLOR, ...COLORS];

const Palette = ({
  // parent props
  preset,
  updateColor,
  // tooltip injected
  handleClose,
}) => {
  const { t } = useTranslation();
  const [currentColor, setCurrentColor] = useState(preset.color);
  const handleChange = (c) => {
    setCurrentColor(c.hex);
  };
  const handleConfirm = () => {
    updateColor(currentColor);
    handleClose();
  };
  return (
    <div className="palette">
      <div className="palette-heading">
        <div className="fake-checkbox" style={{ backgroundColor: currentColor }} />
        <div className="palette-heading-text">{preset.name}</div>
      </div>
      <SketchPicker
        color={currentColor}
        disableAlpha
        presetColors={PRESET_COLORS}
        onChange={handleChange}
      />
      <div className="palette-actions">
        <Button size="small" onClick={handleClose}>
          {t("actions.cancel")}
        </Button>
        <Button
          onClick={handleConfirm}
          size="small"
          color="primary"
          autoFocus
          disabled={preset.color === currentColor}
          endIcon={<Check />}
        >
          {t("actions.confirm")}
        </Button>
      </div>
    </div>
  );
};

Palette.propTypes = {
  // parent props
  preset: PropTypes.object.isRequired,
  updateColor: PropTypes.func.isRequired,
  // tooltip injected
  handleClose: PropTypes.func.isRequired,
};

export default Palette;
